import { FeatureCardItem } from '../../components/blocks/FeaturesCards.builder';
import { generateItemListSchema } from './itemListSchemaGenerator';
import {
  NonStringThing,
  SchemaInput,
  SchemaType,
} from './structuredData.types';

/**
 * Convenience function for generating structured data from feature cards
 */
export const generateFeatureCardsSchema = (
  schemaType: SchemaType,
  heading: string,
  featureCards: FeatureCardItem[],
  options?: {
    description?: string;
    url?: string;
    organizationName?: string;
  }
): NonStringThing | null => {
  if (schemaType === 'none' || !featureCards?.length) {
    return null;
  }

  // Transform feature cards to schema input items
  const schemaItems: SchemaInput[] = featureCards.map((card) => ({
    title: card.title,
    description: card.body,
    image: card.image,
    url: card.link,
    ...(card.price && { price: card.price }),
    ...(card.currency && { currency: card.currency }),
    ...(card.availability && { availability: card.availability }),
  }));

  return generateItemListSchema({
    schemaType,
    heading,
    description: options?.description,
    items: schemaItems,
    url: options?.url,
    organizationName: options?.organizationName,
  });
};
